
export default {
  head() {
    return {
      title:
        "Agence Google Ads | SEA à Fort-de-France dès 290€/mois - ALEO AGENCY",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "ALEO, agence Google Ads à Fort-de-France certifiée Google Partner, accompagne les entreprises foyalaises pour accroître leur visibilité en ligne et acquérir de nouveaux clients.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content:
            "Agence Google Ads à Fort-de-France dès 290€/mois - ALEO AGENCY",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "ALEO, agence Google Ads à Fort-de-France certifiée Google Partner, accompagne les entreprises foyalaises pour accroître leur visibilité en ligne et acquérir de nouveaux clients.",
        },
      ],
    };
  },
};
